import { createSlice } from "@reduxjs/toolkit";

export const chart = createSlice({
  name: "chart",
  initialState: {
    dataChart: {}
  },
  reducers: {
    storeDataChart: (state, action) => {
      state.dataChart = action.payload;
    },
  },
});

export const {
    storeDataChart
} = chart.actions;

export default chart.reducer;